/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DeleteDocumentResponse interface.
 */
export function instanceOfDeleteDocumentResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    return true;
}
export function DeleteDocumentResponseFromJSON(json) {
    return DeleteDocumentResponseFromJSONTyped(json, false);
}
export function DeleteDocumentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
        'documentId': json['documentId'],
    };
}
export function DeleteDocumentResponseToJSON(json) {
    return DeleteDocumentResponseToJSONTyped(json, false);
}
export function DeleteDocumentResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
        'documentId': value['documentId'],
    };
}
